module.exports = __webpack_public_path__ + "img/box5-03.2535b80e.png";